angular.module('mtic.components.mtic_resource', [
  'ngAnimate'
]).directive('mticResource', function (
  $log,
  api,
  $timeout,
  language,
  EventManager,
  ASSET_HOST,
  LearningEnvironmentService,
  ComponentIframeCom,
  MapStateService
) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
      resource: '=',
      moduleId: '=?',
      classId: '=?',
      windowId: '@',
      scrollFrame: '@?'
    },
    link: function (scope, element, attr) {
      // Set Managers
      //console.log('from mtic resource ! ')
      var eventManager = new EventManager('mticResource', scope)
      scope.scrollFrame = scope.scrollFrame || 'no';

      $log.log('MTIC RESOURCE : ' , scope.resource)

      eventManager.broadcast('request-next-item', scope.resource.slug);
      $timeout(function(){        
        scope.next_item = MapStateService.getNextAvailableItem();
      }, 500)

      var componentIframeCom = new ComponentIframeCom('mticResource', scope, {
        containerId: 'lesson-container',
        windowId: scope.windowId,
        scrolling: scope.scrollFrame,
      });

      // Scope Vars
      scope.currentScore = 0;
      scope.showUrl = false;
      scope.language = language;
      scope.notLoaded = true;
      scope.questionaire = {
        isShown: false,
        feedbackGiven: false,
        givingFeedback: false,
        getItemFeedback: function (feedback) {
          if (this.info && !this.givingFeedback) {
            this.givingFeedback = true;
            api.submitItemEndQuestionaire(scope.resource.id, {
              feedback: feedback,
              miscData: scope.questionaire.info
            }).
            then(function () {
              eventManager.broadcast('resource:feedback:given')
            }, function () {
              $log.error('Failed to give feedback!')
            })
          } else {
            $log.warn('scope.questionaire.info', scope.questionaire.info)
            throw "Missing questionaire.info to submit feedback!"
          }
        }
      }
      scope.replayItem = function () {
        scope.show_medal = false;
        scope.questionaire.isShown = false;
        eventManager.resetResourceSession();
        componentIframeCom.reloadUrl(scope.resource.slug, scope.resource.hostUrl, scope.resource.content, true)
      }
      scope.unloadItem = function () {        
        scope.show_medal = false;
        eventManager.broadcast('module:close:resource');
        language.resetAvilableOptions();
      }
      scope.getImageUrlBySlug = (slug) => {
        return ASSET_HOST.IMAGE[slug];
      }

      var updateStarsDisplayConfig = function(){
        scope.starsFormat = 'stars-3';
        scope.ribbonType = 'b';
        scope.starsShown = 0;
        if (scope.resource && scope.resource.display){
          var color = scope.resource.display.color;
          if (color === 'blue'){
            scope.ribbonType = 'a';
            scope.starsFormat = 'stars-1';
          }
          if (color === 'red'){
            scope.ribbonType = 'b';
            scope.starsFormat = 'stars-3';
          }
          if (color === 'black'){
            scope.ribbonType = 'c';
            scope.starsFormat = 'stars-3';
          }
          if (scope.resource.resource_type === 'assessment')
          {
            scope.starsFormat = 'assessment';
            scope.ribbonType = 'c';
          }
          /*
          if (!LearningEnvironmentService.givePostItemQuestionnaire(scope.moduleId) && )
          {
            scope.starsFormat = 'not-c3';
          }
          */
        }else if (scope.resource.resource_type === 'baseline')
        {
          scope.starsFormat = 'assessment';
          scope.ribbonType = 'c';
        }
        $timeout(animateStars, 20);
      }

      var getElementForStarAnimation = function(elementId){
        var el = document.getElementById(elementId);
        el.style.opacity = 0
        el.style.display = 'block'
        return el;
      }

      var animateStars = function(){
        // $log.log('animating stars', scope.starsFormat, scope.currentScore);
        var showAdditionalStar = function () {
          scope.starsShown++;
        }
        var score = scope.currentScore || 0;
        scope.starsShown = 0;
        if (scope.starsFormat === 'stars-1') {
          // $log.log('animating single star', scope.starsFormat, scope.currentScore);
          $timeout(showAdditionalStar, 500);
          return;
        }
        // $log.log('animating 3 stars', scope.starsFormat, scope.currentScore);
        var scoring_structure = [0.5, 0.8, 1];
        if(scope.resource.slug.indexOf('run_like_math') > -1){
          scoring_structure = [0.25, 0.5, 0.75]
        }
        if (score >= scoring_structure[0]){
          $timeout(showAdditionalStar, 500);
        }
        if (score >= scoring_structure[1]){
          $timeout(showAdditionalStar, 800);
        }
        if (score >= scoring_structure[2]){
          $timeout(showAdditionalStar, 1000);
        }
        if(scope.resource.slug.indexOf('run_like_math') > -1 && score === 1){
          $timeout(function(){
            scope.show_medal = true;
          }, 1200)
        }
      }

      scope.getCurrentResourceName = function(){        
        var resourceSlug = scope.resource.slug;
        var resourceName;
        if(resourceSlug === 'run_like_math' || resourceSlug.indexOf('run_like_math') === -1 || resourceSlug.indexOf('lv_') === -1){
          resourceName = language.get(resourceSlug)
        }else{
          var splt = resourceSlug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = resourceSlug.replace('_'+level, '');
          resourceName = language.get(trans_slug)+ ' ' + level;
        }
        
        if(!resourceName){
          resourceName = resourceSlug;
        }
        return resourceName;
      }

      scope.loadNextItem = function(){
        if (scope.resource.notification_slug) {
          scope.unloadItem();
          return;
        }
        scope.next_item = MapStateService.getNextAvailableItem();
        $log.log('GOT NEXT ITEM : ', scope.next_item);        
        if(!scope.next_item || (scope.next_item.locked && scope.currentScore === 0)){
          return;
        }
        //eventManager.broadcast('module:close:resource');
        // $timeout(function(){
        //   
        // }, 100);
        
        scope.show_medal = false;
        eventManager.broadcast('module:open:resource', scope.next_item);
        scope.questionaire.isShown = false;
        eventManager.resetResourceSession();
        componentIframeCom.reloadUrl(scope.next_item.slug, scope.next_item.hostUrl, scope.next_item.content, true);
        scope.resource = scope.next_item;
        eventManager.broadcast('request-next-item', scope.resource.slug);
        $timeout(function(){        
          scope.next_item = MapStateService.getNextAvailableItem();
        }, 500)
      }

      // Debug overwrites
      /*
      window.exposeUrl = function(){
        scope.showUrl = !scope.showUrl;
      }
      */

      // Listeners
      eventManager.listen('mticResource:RESOURCE_REFRESH_REQUEST', function() {
        $timeout(function(){
          scope.questionaire.feedbackGiven = true;
          scope.questionaire.info = null;
          scope.questionaire.givingFeedback = false;
          scope.replayItem();
        }, 1000);
      })
      eventManager.listen('mticResource:REQUEST_CLOSE', function() {
        scope.unloadItem();
      })
      eventManager.listen('resource:feedback:given', function () {
        updateStarsDisplayConfig();
        scope.questionaire.feedbackGiven = true;
        scope.questionaire.info = null;
        scope.questionaire.givingFeedback = false;
      });
      eventManager.listen('resource:score:submitted', function (e, eventData) {
        scope.currentScore = eventData.score;
        if(scope.resource.resource_type === 'embedded_notification'){
          return;
        }
        scope.questionaire.isShown = true;
        scope.questionaire.info = eventData;
        scope.questionaire.feedbackGiven = true;
        if (scope.resource.resource_type !== 'assessment' && LearningEnvironmentService.givePostItemQuestionnaire(scope.moduleId, scope.resource.slug)) {
          scope.questionaire.feedbackGiven = false;
        }else if(eventData.slug === 'mtic_teacher_offboarding'){
          scope.questionaire.isShown = false;
          scope.teacher_test_complete = true;
        }else if(eventData.slug === 'mtic_student_offboarding'){
          scope.questionaire.isShown = false;
          scope.student_test_complete = true;
        }else if(eventData.slug === 'mtic_post_test'){
          scope.questionaire.isShown = false;
          scope.student_test_complete = true;
          scope.is_post_test = true;
        } else {
          updateStarsDisplayConfig();
        }
      });
      eventManager.listen('resource:unload:baseline', function(){
        scope.unloadItem();
      });

      scope.unload_student_questionaire = function(show_student_offboarding){
        $log.log('unload_student_questionaire :  ', show_student_offboarding, scope.is_post_test)
        if(show_student_offboarding && scope.is_post_test){
          $timeout(function(){
            eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true, isBaseline: true});
          }, 1000)
        }
        scope.student_test_complete = false;
        scope.teacher_test_complete = false;
        eventManager.broadcast('hide-notification-iframe');
        scope.unloadItem();
      }


      // Init

      componentIframeCom.startLoadingResource(scope.resource.slug, scope.resource.hostUrl, scope.resource.content)
    }
  }
});
